import createClient from "openapi-react-query"

import { createApiClient } from "@/api/utils"
import { env } from "@/env"
import type { paths as otaPaths } from "@/types/api/users/schema.gen"

const client = createApiClient<otaPaths>({ baseUrl: env.VITE_API2_URL })

// Vanilla API client
export const $usersApiClient = client.vanillaClient

// React-Query client
export const $rqUsersApiClient = createClient(client.rqClient)
